// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/xxi0uje.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".relation-chip-link[data-v-eb3189ac]{position:relative}.relation-chip-link .v-chip[data-v-eb3189ac]{cursor:pointer}.relation-chip-link .new-window-icon[data-v-eb3189ac]{position:absolute;right:-10px;top:0}.relation-chip-link.disabled[data-v-eb3189ac]{cursor:not-allowed;opacity:.6;pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
